import { Table, Skeleton } from 'antd';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getCreditorBalances } from 'services/tabreport';
import { CREDITORS } from 'events/types';

import { useDashboardContext } from '.';

const Creditors = () => {
  const { columns } = useDashboardContext();

  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);

  const { data, isLoading } = useQuery<any, AxiosError, any>({
    queryKey: [CREDITORS, pageSize, pageIndex],
    queryFn: () => getCreditorBalances(pageSize, pageIndex),
    select: (response) => ({
      data: response.data.data.map((item: any) => ({ ...item, key: item.id })),
      totalRecord: response.data.totalRecord,
    }),
  });
  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          className="h-[calc(100vh-240px)] overflow-y-scroll"
        />
      )}
    </>
  );
};

export default Creditors;
